import { type CSSObject, Stack, Typography, styled } from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 0, 11, 0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 5, 0),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 9, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledContentStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(10),

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
}));

export const StyledTextStack = styled(Stack)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.down('xl')]: {
    flex: 0.95,
  },
  [theme.breakpoints.down('lg')]: {
    flex: 1,
  },
}));

export const MainText = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(4),
  color: theme.palette.invertedContent?.PRIMARY,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 0),
  },
}));

export const PointsWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 4, 4, 0),
  borderRight: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
  flex: 1,
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 0),
    borderRight: 0,
  },
}));

export const RowWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(0.75),
  alignItems: 'flex-start',
}));

export const Point = styled(Stack)(({ theme }) => ({
  height: theme.spacing(1.5),
  width: theme.spacing(1.5),
  minHeight: theme.spacing(1.5),
  minWidth: theme.spacing(1.5),
  ...(theme.mixins.magentaGradient as CSSObject),
  borderRadius: theme.spacing(10),
  marginTop: theme.spacing(1.2),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(1.5),
    height: theme.spacing(1),
    width: theme.spacing(1),
    minHeight: theme.spacing(1),
    minWidth: theme.spacing(1),
  },
}));

export const StyledPointText = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));

export const StyledAccordionStack = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: '1255px',
  [theme.breakpoints.down('sm')]: {
    minHeight: 'auto',
  },
}));

export const StyledInfoStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));
